import { Rating } from 'components'
import qs from 'qs'
import React from 'react'
import { Link } from 'react-router-dom'
import { imageService, routeService, transformerService } from 'services'
import { IResidenceCardProps } from './residence-card.-props.interface'
import './residence-card.scss'

const ResidenceCard: React.FC<IResidenceCardProps> = ({ residence, searchParams, openLinkInNewPage }) => {
  const query_str =
    searchParams &&
    transformerService.toISearchQueryString(
      searchParams.profileTypeId,
      searchParams.cityId,
      searchParams.dateFrom,
      searchParams.dateTo,
      searchParams.eventCode,
      searchParams.guestsPerRoom,
    )

  const link =
    routeService.generateRoutePath('/residence/:residenceId', { residenceId: residence.id }) +
    (query_str ? '?' + qs.stringify(query_str) : '')

  return (
    <Link to={link} className="edisu-residence-card" target={openLinkInNewPage ? '_blank' : '_self'}>
      <div className="residence-card-header">
        <div className="thumb-container">
          <div className="opacity" />
          <img src={imageService.getResidenceMainImgUrl(residence)} alt={residence.nome} />
        </div>

        <span className="edisu-city-name">{residence.citta?.nome}</span>
      </div>

      <div className="residence-card-content">
        <div>
          <div className="edisu-residence-address">{residence.indirizzo}</div>
          <div className="edisu-residence-name">{residence.nome}</div>
        </div>
        {residence.gradimento >= 0 && <Rating value={residence.gradimento} />}
      </div>
    </Link>
  )
}

export default ResidenceCard
